import { CommonModule } from '@angular/common';
import { Component, effect, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { Router, RouterModule } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { APIUrl } from '../constant/api-call';
import { ClientService } from '../services/client.service';
import { AuthService } from '../services/auth.service';
import { ColDef } from 'ag-grid-community';
import { DynamicEntryFormComponent } from '../dynamic-entry-form/dynamic-entry-form.component';
import moment from 'moment';

@Component({
  selector: 'app-form-list',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimeNgModule, RouterModule, DynamicEntryFormComponent],
  templateUrl: './form-list.component.html',
  styleUrl: './form-list.component.css',
})
export class FormListComponent {
  // @ViewChild(DynamicEntryFormComponent) dynamicForm!: DynamicEntryFormComponent;
  public formSubmissionList: any[] = [];
  @ViewChild('dynamicForm') dynamicFormComponent!: DynamicEntryFormComponent;
  public activeRootTabIndex: number = 0;
  public activeChildTabIndex: number = 0;
  public currentForm: any = null;
  public currentChildSubmission: any = null;
  public showEditMode: boolean = false;
  public rowData: any[] = [];
  public commonDataObject = {
    APIObj: APIUrl,
    displayDialog: false,
    deleteDialog: false
  }
  public selectedRow: any = null;
  public expandedFormState: { [key: number]: boolean } = {};
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1
  };
  public columnDefs: ColDef[] = [
    {
      headerName: 'Sr. No.',
      flex: 0.5,
      cellRenderer: (params: any) =>
        params.data.rowType === 'FORM' ? params.data.srNo + '.' : ''
    },
    {
      headerName: 'Form Name',
      flex: 2,
      cellRenderer: (params: any) => {
        if (params.data.rowType === 'FORM') {
          const id = params.data.formId;
          const expanded = this.expandedFormState[id];
          const icon = expanded
            ? '<i class="fa fa-chevron-down toggle-form me-2"></i>'
            : '<i class="fa fa-chevron-right toggle-form me-2"></i>';
          return `
          <span class="toggle-form" style="cursor:pointer">
            ${icon}
            <strong>${params.data.formName}</strong>
          </span>
        `;
        }
        if (params.data.rowType === 'SUBMISSION') {
          return `<span style="padding-left:40px"></span>`;
        }
        return '';
      },
      onCellClicked: (params: any) => {
        if (params.data.rowType !== 'FORM') return;
        const id = params.data.formId;
        this.expandedFormState[id] = !this.expandedFormState[id];
        this.rowData = this.getGroupedFormList(
          this.projectService.getSubmittedFormList()
        );
      }
    },
    {
      headerName: 'User Name',
      flex: 1,
      cellRenderer: (params: any) =>
        params.data.rowType === 'SUBMISSION'
          ? params.data.userName
          : ''
    },
    {
      headerName: 'Submitted Date',
      flex: 1,
      cellRenderer: (params: any) => {
        if (params.data.rowType !== 'SUBMISSION') return '';
        return new Date(params.data.filledDate)
          .toLocaleDateString('en-GB');
      }
    },
    {
      headerName: 'Submitted Time',
      flex: 1,
      cellRenderer: (params: any) => {
        if (params.data.rowType !== 'SUBMISSION') return '';
        return moment(new Date(params.data.filledDate)).format('hh:mm A');
      }
    },
    {
      headerName: 'Action',
      flex: 0.8,
      cellRenderer: (params: any) => {
        if (params.data.rowType !== 'SUBMISSION') return '';
        return `<i class="fa fa-edit text-primary edit-btn" style="cursor:pointer"></i>`;
      },
      onCellClicked: (params: any) => {
        if (params.data.rowType !== 'SUBMISSION') return;
        const target = params.event.target as HTMLElement;
        if (target.classList.contains('edit-btn')) {
          this.editFormData(params.data);
        }
      }
    }
  ];
  public gridApi: any;
  public dialogHeader: string = 'Submission Form';
  public loading: boolean = false;
  public userRole: any;
  public userCode: any;

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    public authService: AuthService,
    public projectService: ProjectService,
    public route: Router
  ) { }

  async ngOnInit() {
    await this.projectService.getMasterData();
    this.getRowData();
    this.projectService.loading.set(true);
    this.userRole = sessionStorage.getItem('user_category_code');
    this.userCode = sessionStorage.getItem('user_code');
    setTimeout(() => {
      let filteredFormList = this.projectService?.getSubmittedFormList()
        .map(form => {
          const processedForm = { ...form };
          if (this.userRole === 'USER') {
            processedForm.form_submission = form?.form_submission?.filter((e: any) => {
              return this.userCode == e?.user_code;
            });
          } else if (this.userRole === 'ADMIN') {
            processedForm.form_submission = form?.form_submission?.filter((e: any) => {
              return e?.user_category_key === "USER" ||
                (e?.user_category_key === "ADMIN" && e?.user_code == this.userCode);
            });
          }
          return processedForm.form_submission?.length > 0 ? processedForm : null;
        })
        .filter(form => form !== null);
      this.formSubmissionList = filteredFormList;
      if (this.formSubmissionList?.length > 0) {
        this.showEditMode = true;
      } else {
        this.loading = true;
      }
      this.selectRootTab(0);
    }, 500)
  }

  onGridReady(params: any) {
    this.gridApi = params.api;

    window.addEventListener('resize', () => {
      this.gridApi.sizeColumnsToFit();
    });
  }

  onFirstDataRendered(params: any) {
    params.api.sizeColumnsToFit();
  }

  getRowData() {
    setTimeout(() => {
      this.rowData = this.getGroupedFormList(this.projectService.getSubmittedFormList());
      this.projectService.loading.set(false);
      if (this.rowData?.length === 0) {
        this.loading = true;
      }
    }, 500);
  }

  onFormNameChange(name: any) {
    this.dialogHeader = name;
  }

  getGroupedFormList(apiData: any[]) {
    const rows: any[] = [];
    let srNo = 1;
    apiData?.forEach((form: any) => {
      if (form.form_submission?.length) {
        if (this.expandedFormState[form.form_id] === undefined) {
          this.expandedFormState[form.form_id] = true;
        }
        rows.push({
          rowType: 'FORM',
          srNo: srNo++,
          formId: form.form_id,
          formName: form.form_name
        });
        if (!this.expandedFormState[form.form_id]) return;
        form.form_submission.forEach((sub: any) => {
          rows.push({
            rowType: 'SUBMISSION',
            formId: form.form_id,
            userName: sub.filled_username,
            filledDate: sub.filled_datetime,
            submissionId: sub.form_submission_id
          });
        });
      }
    });
    return rows;
  }

  openSubmissionForm() {
    this.commonDataObject.displayDialog = true;
    // setTimeout(() => {
    //   if (this.dynamicForm) {
    //     this.dynamicForm.resetForm();
    //     this.dynamicForm.autoSelectSingleForm();
    //   }
    // });
  }

  async onFormSaved() {
    await this.getRowData();
    this.commonDataObject.displayDialog = false;
    this.dialogHeader = 'Submission Form';
  }

  editFormData(rowData: any) {
    this.showEditMode = false;
    const payload = {
      form_submission_id: this.currentChildSubmission?.form_submission_id
    }
    this.clientService.postAPI(this.commonDataObject.APIObj.SUBMISSION_FORM_DETAILS, payload).subscribe((res: any) => {
      if (res && res.code == 'CSR_MS_OK_200') {
        this.projectService.dynamicEntryFormData.set(res?.data[0]);
        this.route.navigate(['/form_submission']);
      }
      setTimeout(() => {
        this.projectService.loading.set(false);
      }, 2000);
    },
      (error) => {
        setTimeout(() => {
          this.projectService.loading.set(false);
        }, 2000);
      });
  }

  confirmDelete() {
    this.commonDataObject.deleteDialog = false;
  }

  editEntryForm() {
    this.editFormData(this.currentChildSubmission);
  }

  selectRootTab(index: number) {
    this.activeRootTabIndex = index;
    this.currentForm = this.formSubmissionList[index];
    this.activeChildTabIndex = 0;
    if (this.currentForm?.form_submission?.length > 0) {
      this.selectChildTab(0);
    } else {
      this.currentChildSubmission = null;
    }
  }

  selectChildTab(index: number) {
    if (index !== this.activeChildTabIndex || index === 0) {
      this.activeChildTabIndex = index;
      this.currentChildSubmission = this.currentForm?.form_submission[index];
      this.editSubmission();
    }
  }

  editSubmission() {
    this.projectService.loading.set(true);
    const payload = {
      form_submission_id: this.currentChildSubmission?.form_submission_id
    }
    this.clientService.postAPI(this.commonDataObject.APIObj.SUBMISSION_FORM_DETAILS, payload).subscribe((res: any) => {
      if (res && res.code == 'CSR_MS_OK_200') {
        this.dynamicFormComponent?.loadSubmissionForEdit(res?.data[0]);
        setTimeout(() => {
          this.dynamicFormComponent?.dynamicForm?.disable();
          this.dynamicFormComponent?.formSelectControl.disable();
          this.dynamicFormComponent['showActionBar'] = false;
        }, 400)
      }
      setTimeout(() => {
        this.projectService.loading.set(false);
      }, 2000);
    },
      (error) => {
        setTimeout(() => {
          this.projectService.loading.set(false);
        }, 2000);
      });
  }
}
